<template>
  <b-form-group label="Instituição Financeira">
    <multiselect
      label="name"
      track-by="name"
      :options="options"
      :loading="loading"
      :disabled="disabledSelect"
      v-model="valorInstituicaoFinanceira"
      placeholder="Selecione uma instituição financeira"
      :class="{ 'is-valid': valorInstituicaoFinanceira }"
    >
      <span slot="noOptions">Nenhuma instituição disponível</span>
    </multiselect>
  </b-form-group>
</template>

<script>
import Multiselect from "vue-multiselect";
import { InstituicaoFinanceiraService } from "../../../../../services/astec/InstituicaoFinanceira";

export default {
  name: "SelectInstituicaoFinanceira",
  components: {
    Multiselect,
  },
  props: {
    value: { type: Object, default: null },
    disabledSelect: { type: Boolean, default: false },
  },
  data() {
    return {
      options: [],
      loading: false,
      valorInstituicaoFinanceira: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.valorInstituicaoFinanceira = newValue;
    },
    valorInstituicaoFinanceira(newValue) {
      this.$emit("input", newValue);
    },
  },
  async mounted() {
    await this.carregaInstituicaoFinanceira();
  },
  computed: {
    isDisabled() {
      return this.disabledSelect;
    },
  },
  methods: {
    async carregaInstituicaoFinanceira() {
      const cdCooperado = this.$store.state.filtroProjetoAstec?.cdCooperado;
      if (!cdCooperado) {
        console.warn("Cooperado não encontrado no store");
        return;
      }
      try {
        this.loading = true;
        this.options = await InstituicaoFinanceiraService.buscarLkpInstituicaoFinanceira(
          cdCooperado
        );
      } catch (error) {
        console.error("Erro ao carregar Instituições Financeiras", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="css" scoped>
@keyframes pulse-danger {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}
</style>
